import defaultSettings from '@/settings'

const title = defaultSettings.title || '心典律师事务所'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
